import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { AbstractBaseDetailsComponent } from 'src/app/core/component/abstract-base-details-component';
import { SystemConfigSettingModel } from 'src/app/shared/model/system-config-setting-model';
import { CommonSelectListService } from 'src/app/shared/service/common-select-list.service';
import { SystemConfigService } from 'src/app/system-config/service/system-config.service';
import { environment } from 'src/environments/environment';
import { OrgProfileModal } from '../../org-profile/modal/org-profile-modal';
import { Organization } from '../../purchase-order/modal/organization';
import { SalesOrderModal } from '../modal/sales-order-modal';
import { SoDetailModal } from '../modal/so-detail-modal';
import { SalesOrderServiceService } from '../service/sales-order-service.service';
import { DomSanitizer } from '@angular/platform-browser';
import { UserModal } from '../../user/modal/user-modal';
import { ResponseCode } from '../../../core/constant/response-code';
import { lstat } from 'fs';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

const amendedPoNo = 'amendedPoNo.';
const amendedPoDate = 'amendedPoDate';
const selectedDeliveryNote = 'selectedDeliveryNote';
const selectedDocumentNotes = 'selectedDocumentNotes';
const spiIns = 'spiIns';
const items = 'item';
const moduleName = 'SalesOrder';

@Component({
  selector: 'app-sales-order-print',
  templateUrl: './sales-order-print.component.html',
  styleUrls: ['./sales-order-print.component.css'],
})
export class SalesOrderPrintComponent extends AbstractBaseDetailsComponent implements OnInit {
  public organization: OrgProfileModal;

  @Input()
  public isHideHeaderFooter: boolean;

  @Input()
  public data: SalesOrderModal;

  public imgURL: string;

  @Input()
  public isWorkOrder: boolean;

  public modeOfTransport: string;

  public sysConfigModel: SystemConfigSettingModel = new SystemConfigSettingModel(this.systemConfigService);
  totalCost: number;
  totalAmountWithGST: number;
  totalDiscount: number;
  totalGSTAmount: number;
  public bank: Array<Organization>;
  subject: string;
  amendedPoNo: string;
  amendedPoDate: string;
  poDate: string;
  poReference: string;
  selectedDeliveryNote: Array<DeliveryNote>;
  deliveryNotes: Array<DeliveryNote>;
  selectedDocumentNotes: Array<DeliveryNote>;
  documentNotes: Array<DeliveryNote>;
  splInstruction: Array<DeliveryNote>;
  paramArray = new Array<DynamicParams>();
  paramobj = new DynamicParams();
  spiIns: string;
  isDiagonal: boolean = false;
  isLifeoline: boolean = false;
  totalWeight: number;
  taxableTotal: number;
  isCgst: boolean = false;
  isIgst: boolean = false;
  printData: SOPrintModal;
  date = new Date();
  dataLocalUrl: any;
  paymentDays: number = 30;
  printby: UserModal;
  qrImgURL: string;
  signImg: string;
  itemTupleIds = [];
  totalAvlStock:any = 0;
  @Input() public isUpdateComponent: boolean;
  @Output('onSave') onSave: EventEmitter<any> = new EventEmitter<any>();
  @Output('onCancel')
  public cancelCallback: EventEmitter<SoDetailModal> = new EventEmitter<SoDetailModal>();
  totalFrieght: number;
  FinalFrieghtAmount: any;
  totalproductionQty: number;
  constructor(
    private systemConfigService: SystemConfigService,
    public toaster: ToastrService,
    public service: SalesOrderServiceService,
    public commonSerivce: CommonSelectListService,
    public ngbService : NgbModal,
    public SOService:SalesOrderServiceService
  ) {
    super(toaster);
    if (localStorage.getItem('activeUser')) {
      this.printby = JSON.parse(localStorage.getItem('activeUser'));
    }
  }

  ngOnInit() {
    this.getOrganization();
    if (this.data.grandTotal) {
      this.data.grandTotal = Number(this.data.grandTotal);
    }
    if (this.data.party.gstNumber) {
      this.data.stateCode = this.data.party.gstNumber.substring(0, 2);
    }
    this.isDiagonal = this.sysConfigModel.partnerKey == 'Diagonal';
    if (this.sysConfigModel.partnerKey == 'Alaska' && this.sysConfigModel.printPartner == 'Lifeoline') {
      this.isLifeoline = true;
    } else {
      this.isLifeoline = false;
    }

    this.getById();
    this.setData();
    setTimeout(()=>{
      this.getTotal();
    },600)
    // this.getTotal();
    this.getDeliveryNotes();
    this.getOrganizationList();
    this.getactiveuserDetails();
    
    this.getByModuleNameId(this.data.id);
  }

  getById(){
    this.SOService.getById(this.data.id).subscribe((res) =>{
      console.log("itemProperty",res);
      
      this.data.salesOrderItemDetails.forEach((ls) =>{
          res.data.salesOrderItemDetails.forEach((item) =>{
             if(ls.itemTupleId == item.itemTupleId){
              ls.itemProperties = item.itemProperties;
            }
        })
      })
    })
  }

  getOrganizationList() {
    this.service.getOrganizationList().subscribe((response) => {
      if (response.responseCode === ResponseCode.OK) {
        this.bank = new Array<Organization>();
        this.bank = response.dataList;
        this.getImageUrl();
      }
    });
  }

  getactiveuserDetails() {
    if (this.printby.footerSign) {
      this.signImg = environment.DOWNLOAD_GET_FILE + this.printby.footerSign;
    }
  }

  getOrganization() {
    this.commonSerivce.getOrganizationData().subscribe((res) => {
      this.organization = new OrgProfileModal();
      this.organization = res.data;
      if (this.organization.qrCode) {
        this.qrImgURL = environment.DOWNLOAD_GET_FILE + this.organization.qrCode;
      }
      // if (this.organization.footerSign) {
      //   this.signImg = environment.DOWNLOAD_GET_FILE + this.organization.footerSign;
      // }
    });
  }

  getImageUrl() {
    if (this.bank[0]) {
      this.imgURL = environment.DOWNLOAD_GET_FILE + this.bank[0].headerLogo;
    }
  }

  getAmountInWordTotal() {
    if (this.totalAmountWithGST) {
      let total = Number(this.totalAmountWithGST + this.getFreight());
      return total ? total.toFixed(2) : 0;
    }
    return 0;
  }

  setData() {
    if (this.data && this.data.salesOrderDetails && this.sysConfigModel.labelSupport) {
      this.data.salesOrderDetails.sort((a, b) => (a.id < b.id ? 1 : -1));
      let oldItem = undefined;
      let salesOrderDetails = [];
      this.data.salesOrderDetails.forEach((item, index) => {
        if (oldItem && item.setNo === oldItem.setNo && item.isSet) {
          const oldind = salesOrderDetails.indexOf(oldItem);
          if (salesOrderDetails[oldind] && !salesOrderDetails[oldind]['details']) {
            salesOrderDetails[oldind]['details'] = item;
          }
        } else {
          salesOrderDetails.push(item);
          oldItem = item;
        }
      });
      this.data.salesOrderDetails = salesOrderDetails;
    }
  }
  getTotal() {
    console.log("SO",this.data);
    let req:any ={};
    if (this.data && this.data.party && this.data.party.gstNumber && this.organization && this.organization.gstin) {
      if (this.organization.gstin.slice(0, 2) === this.data.party.gstNumber.slice(0, 2)) {
        this.isCgst = true;
      } else {
        this.isIgst = true;
      }
    }

    this.totalCost = 0;
    this.totalAmountWithGST = 0;
    this.totalproductionQty = 0;
    this.totalDiscount = 0;
    this.totalGSTAmount = 0;
    this.totalWeight = 0;
    this.taxableTotal = 0;
    let stockList = new Array();
    
    if(this.data){
      if(this.data.freightValue){
        this.totalFrieght = (this.data.freight * this.data.freightValue.value)/100;
        this.FinalFrieghtAmount = this.data.freight + this.totalFrieght;
      }
    }
    
    if (this.data.salesOrderItemDetails) {
      this.data.salesOrderItemDetails.forEach((item: any) => {
        this.itemTupleIds.push(item.itemTupleId);
      });
      req.itemTupleIds = this.itemTupleIds;
      
      this.commonSerivce.getNewCBLWiseStocks(req).subscribe((res) =>{
        stockList = res.dataList;
        console.log("innerstocklist",stockList)
        this.data.salesOrderItemDetails.forEach((item: any) => {
          // if (!item.isDeleted) {
            this.totalAvlStock = 0;
            console.log("item",item);
          this.totalWeight += item.weight;
          this.totalCost = this.totalCost + parseFloat('' + item.price * item.weight);
          this.totalAmountWithGST = this.totalAmountWithGST + parseFloat('' + this.getAmountWithGST(item));
          this.totalDiscount = this.totalDiscount + parseFloat('' + this.getDiscountedAmount(item));
          this.totalGSTAmount = this.totalGSTAmount + parseFloat('' + this.getGstAmount(item));
          this.totalGSTAmount = parseFloat('' + this.totalGSTAmount.toFixed(2));
          this.taxableTotal += this.getTaxableItemTotal(item);
          if (item.details) {
            const price = item.details.price || 0;
            const weight = item.details.weight || 0;
            this.totalCost = this.totalCost + parseFloat('' + price * weight);
            this.totalAmountWithGST = this.totalAmountWithGST + parseFloat('' + this.getAmountWithGST(item.details));
            this.totalDiscount = this.totalDiscount + parseFloat('' + this.getDiscountedAmount(item.details));
            this.totalGSTAmount = this.totalGSTAmount + parseFloat('' + this.getGstAmount(item));
            this.totalGSTAmount = parseFloat('' + this.totalGSTAmount.toFixed(2));
          }

          console.log("uom",item.item.secondaryUom);

          if(item.item.secondaryUom){
            item.item.secondaryweight = item.item.conversionFactor * item.weight;
          } else {
            item.item.secondaryweight = 0;
          }
    
          
          console.log("stockList",stockList);
          stockList.filter((ls => ls.itemTupleId == item.itemTupleId)).map(d => {
            this.totalAvlStock += d.stock;
            item.totalAvlStock = this.totalAvlStock;
          });

          if(item.totalAvlStock == undefined){
            item.totalAvlStock = 0;
          }

          item.productionQty = item.weight - item.totalAvlStock;
          if(item.productionQty < 0){
            item.productionQty = 0;
          }
          this.totalproductionQty += item.productionQty; 
          console.log("totalAvlStock",this.totalAvlStock);
        });
      });
      
    }
    this.totalAmountWithGST = Number(this.totalAmountWithGST.toFixed(2));
    
  }
  getItemTotal(record: SoDetailModal) {
    return record.price * record.weight;
  }
  getTaxableItemTotal(record: SoDetailModal) {

    return record.discount ? record.price * record.weight - this.getDiscountAmount(record)
    : record.price * record.weight;
  }

  getDiscountAmount(record:SoDetailModal){
    return record.discount ? record.price*record.weight*(record.discount/100):0;
  }
  getDiscountedAmount(record: SoDetailModal) {

    if (!record) {
      return 0;
    }
    return record.discount && record.discount > 0
      ? record.price * record.weight - record.price * record.weight * (record.discount / 100)
      : 0;
  }

  getGstAmount(record: SoDetailModal) {
    if (!record) {
      return 0;
    }
    if (record.discount > 0) {
      return this.getDiscountedAmount(record) * (record.gst / 100);
    } else {
      return record.price * record.weight * (record.gst / 100);
    }
  }
  getAmountWithGST(record: SoDetailModal) {
    if (!record) {
      return 0;
    }
    if (record.discount && record.discount > 0) {
      return this.getDiscountedAmount(record) + this.getGstAmount(record);
    } else {
      return record.price * record.weight + this.getGstAmount(record);
    }
  }
  getFreight() {
    if (this.data.freight) {
      let totalFreight =
        Number(this.data.freight) +
        Number(this.data.freight) * Number(this.data.freightValue ? this.data.freightValue.value / 100 : 0);
      return totalFreight;
    }
    return 0;
  }
  getDeliveryNotes() {
    this.deliveryNotes = Array<DeliveryNote>();
    this.deliveryNotes.push(new DeliveryNote('BY HAND', 'BY HAND'));
    this.deliveryNotes.push(new DeliveryNote('SELF FROM OFFICE', 'SELF FROM OFFICE'));
    this.deliveryNotes.push(new DeliveryNote('TRANSPORT', 'TRANSPORT'));
    this.deliveryNotes.push(new DeliveryNote('COURIER', 'COURIER'));
    this.deliveryNotes.push(new DeliveryNote('OTHER', 'OTHER'));

    this.documentNotes = Array<DeliveryNote>();
    this.documentNotes.push(new DeliveryNote('BY HAND', 'BY HAND'));
    this.documentNotes.push(new DeliveryNote('COURIER', 'COURIER'));
    this.documentNotes.push(new DeliveryNote('TRANSPORT', 'TRANSPORT'));
    this.documentNotes.push(new DeliveryNote(' E-MAIL ', ' E-MAIL '));
    this.documentNotes.push(new DeliveryNote('OTHER', 'OTHER'));

    this.splInstruction = Array<DeliveryNote>();
    this.splInstruction.push(new DeliveryNote('HIGH PRIORITY', 'HIGH PRIORITY'));
    this.splInstruction.push(new DeliveryNote('PRIORITY', 'PRIORITY'));
    this.splInstruction.push(new DeliveryNote('NORMAL', 'NORMAL'));
    this.splInstruction.push(new DeliveryNote('OTHER', 'OTHER'));
  }

  generatePrint(save?: boolean) {
    this.printData = new SOPrintModal();
    this.paramArray = new Array<DynamicParams>();
    this.printData.venderCode = this.data.party.vendorCode;
    if (this.data.poReference) {
      this.printData.poRefNo = this.data.poReference;
    } else {
      this.printData.poRefNo = this.poReference;
    }
    this.printData.soNo = this.data.soNumber;
    this.printData.poDate = this.poDate;
    this.printData.subjectDetails = this.subject;
    this.printData.amendedPoNo = this.amendedPoNo;
    this.printData.amendedPoDate = this.amendedPoDate;
    this.printData.deliveryNote = new Array<string>();
    this.printData.documentNote = new Array<string>();
    this.printData.spiIns = this.spiIns;
    this.printData['selectedDeliveryNote'] = this.selectedDeliveryNote;
    this.printData['selectedDocumentNotes'] = this.selectedDocumentNotes;
    if (this.selectedDeliveryNote) {
      this.printData.deliveryNote = this.selectedDeliveryNote.map((la) => la.name);
    }
    if (this.selectedDocumentNotes) {
      this.printData.documentNote = this.selectedDocumentNotes.map((la) => la.name);
    }
    this.printData.modeOfTransport = this.modeOfTransport;
    this.printData.remark = this.data.remark;
    this.printData.venderCode = this.data.party.vendorCode;
    if (this.data && this.data.createdBy) {
      this.printData.engineer = this.data.createdBy.firstname + ' ' + this.data.createdBy.lastname;
    }
    this.printData.hideHeaderFooter = this.isHideHeaderFooter;
    this.printData.paymentDays = this.paymentDays;
    this.printData.isWorkOrder = this.isWorkOrder;
    if (!save) {
      this.printData.soId = this.data.id;
      this.service.getSoPrint(this.printData);
    } else {
      this.onSave.emit(this.printData);
    }
    if (this.amendedPoNo) {
      this.paramobj = new DynamicParams();
      this.paramobj.keyName = amendedPoNo;
      this.paramobj.value = this.amendedPoNo;
      this.paramobj.valueObject = null;
      this.paramobj.entityId = this.data.id;
      this.paramobj.moduleName = moduleName;
      this.paramArray.push(this.paramobj);
    }
    if (this.amendedPoDate) {
      this.paramobj = new DynamicParams();
      this.paramobj.keyName = amendedPoDate;
      this.paramobj.value = this.amendedPoDate;
      this.paramobj.valueObject = null;
      this.paramobj.entityId = this.data.id;
      this.paramobj.moduleName = moduleName;
      this.paramArray.push(this.paramobj);
    }
    if (this.selectedDeliveryNote && this.selectedDeliveryNote.length > 0) {
      this.paramobj = new DynamicParams();
      this.paramobj.keyName = selectedDeliveryNote;
      this.paramobj.value = null;
      this.paramobj.valueObject = this.selectedDeliveryNote;
      this.paramobj.entityId = this.data.id;
      this.paramobj.moduleName = moduleName;
      this.paramArray.push(this.paramobj);
    }
    if (this.selectedDocumentNotes && this.selectedDocumentNotes.length > 0) {
      this.paramobj = new DynamicParams();
      this.paramobj.keyName = selectedDocumentNotes;
      this.paramobj.value = null;
      this.paramobj.valueObject = this.selectedDocumentNotes;
      this.paramobj.entityId = this.data.id;
      this.paramobj.moduleName = moduleName;
      this.paramArray.push(this.paramobj);
    }
    if (this.spiIns) {
      this.paramobj = new DynamicParams();
      this.paramobj.keyName = spiIns;
      this.paramobj.value = this.spiIns;
      this.paramobj.valueObject = null;
      this.paramobj.entityId = this.data.id;
      this.paramobj.moduleName = moduleName;
      this.paramArray.push(this.paramobj);
    }
    this.amendedPoNo = undefined;
    this.amendedPoDate = undefined;
    this.spiIns = undefined;
    if (this.paramArray.length > 0) {
      this.service.getPrintParameters(this.paramArray).subscribe((res) => {
        console.log('abc=>', res);
      });
    }
  }

  getByModuleNameId(id: number) {
    this.service.getByModuleNameAndEntityId(id).subscribe((res) => {
      res.dataList.forEach((res) => {
        if (res.keyName == amendedPoNo) {
          if (!this.amendedPoNo) this.amendedPoNo = res.value;
        }
        if (res.keyName == amendedPoDate) {
          if (!this.amendedPoDate) this.amendedPoDate = res.value;
        }
        if (res.keyName == selectedDeliveryNote) {
          if (!this.selectedDeliveryNote || this.selectedDeliveryNote.length == 0) {
            console.log('selected d notes= >', JSON.parse(res.value));
            this.selectedDeliveryNote = JSON.parse(res.value);
          }
        }
        if (res.keyName == selectedDocumentNotes) {
          if (!this.selectedDocumentNotes || this.selectedDocumentNotes.length == 0) {
            console.log('selected dd notes= >', JSON.parse(res.value));
            this.selectedDocumentNotes = JSON.parse(res.value);
          }
        }
        if (res.keyName == spiIns) {
          if (!this.spiIns) this.spiIns = res.value;
        }
      });
    });
  }

  onModalClose() {
    this.ngbService.dismissAll();
  }
}
class DeliveryNote {
  id: string;
  name: string;
  constructor(id: string, name: string) {
    this.id = id;
    this.name = name;
  }
}

export class SOPrintModal {
  venderCode: string;
  poRefNo: string;
  poDate: string;
  amendedPoNo: string;
  amendedPoDate: string;
  deliveryNote: Array<string>;
  documentNote: Array<string>;
  spiInstruction: Array<string>;
  spiIns: string;
  modeOfTransport: string;
  remark: string;
  soId: number;
  engineer: string;
  subjectDetails: string;
  soNo: string;
  hideHeaderFooter: boolean = false;
  paymentDays: number;
  isWorkOrder: boolean;
}

export class DynamicParams {
  value: any;
  keyName: string;
  valueObject: Array<any>;
  entityId: number;
  moduleName: string;
}

export class valueObjectClass {
  id: number;
  selectedDeliveryNote: string;
  selectedDocumentNotes: string;
}
